import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function DrugView(props){
  const [inputValue, setInputValue] = useState('');
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [oprows, setOpRows] = useState([]);
  const [opvData, setOpvData] = useState([]);
  const [savrows, setSavRows] = useState([]);
  const [savData, setSavData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsindent, setRowsindent] = useState([]);
  const [rowsip, setRowsIp] = useState([]);
  const [indentData, setIndentData] = useState([]);
  const [opData, setOpData] = useState([]);
  const [ipData, setIpData] = useState([]);
  const [searchClicked, setSearchClicked] = useState(false);

  const handleInputChange = (event) => {
        setInputValue(event.target.value);
    }
     useEffect(() => {
    if (searchClicked) {
      fetchData();
    }
  }, [searchClicked]);

  function fetchData() {
    setIsLoading(true);
    axios.get(baseUrl+`pat-search/?search=${searchTerm}`)
      .then(response => {
        setPatients(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
useEffect(() => {
    fetchOpvData();
    fetchSavData();
  }, [selectedDate]);

  useEffect(() => {
      if (opvData.length > 0) {
        setOpRows(opvData);
      }
  }, [opvData]);
  function fetchOpvData() {
    setIsLoading(true);
    const formattedDate = selectedDate.toISOString().substring(0, 10);
    axios.get(`${baseUrl}op-cons-view/${formattedDate}/`)
      .then(response => {
        setOpvData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
  useEffect(() => {
      if (savData.length > 0) {
        setSavRows(savData);
      }
  }, [savData]);
  function fetchSavData() {
    setIsLoading(true);
    const formattedDate = selectedDate.toISOString().substring(0, 10);
    axios.get(`${baseUrl}pharm-sale-other/${formattedDate}/`)
     .then(response => {
        setSavData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

  function handleSearchButtonClick() {
    setSearchClicked(true);
  }

  function handleSearchInputChange(event) {
    setSearchTerm(event.target.value);
  }
const columnsop = [
    { field: 'appt_id', headerName: 'Appt Id', width: 200},
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 200},
    { field: 'pat__patient', headerName: 'Patient', width: 200 },
    { field: 'pat__mobile', headerName: 'Mobile', width: 100 },
    { field: 'cons__consultant', headerName: 'Consultant', width: 150 },
    { field: 'addedby', headerName: 'Added by', width: 150 },
    { field: 'add_date_date', headerName: 'Appt Slot', width: 150 },
    { field: 'appt_time', headerName: 'Appt Time', width: 150 },
    { field: 'action', headerName: 'Action',
      renderCell: (params) => (
          <Link to={`/drug-pay-other/${params.row['pat__pat_id']}`} className="btn btn-success">
            View
          </Link>
      ),
    width: 100 },
  ];


   const columns = [
    {field:'id', headerName:'Id'},
    {field:'pat_id', headerName:'Patient ID',
      renderCell: (params) => (
          <Link to={`/drug-pay-other/${params.value}`}>
            {params.value}
          </Link>
      )
      },
    {field:'patient', headerName:'Patient', width: 220},
    {field:'gender', headerName:'Gender'},
    {field:'age', headerName:'Age'},
    {field:'marital_status', headerName:'Marital Status'},
    {field:'adhar', headerName:'Aadhar'},
    {field:'address1', headerName:'Address', width: 220},
    {field:'mobile', headerName:'mobile'},
  ];
 useEffect(() => {
    fetchData1();
  }, []);

const getRowId = (row) => row.appt_id;
  useEffect(() => {
      if (opData.length > 0) {
        setRows(opData);
      }
  }, [opData]);
  function fetchData1() {
    setIsLoading(true);
    axios.get(`${baseUrl}cons-drug-view/`)
      .then(response => {
        setOpData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

    const columns1 = [
    { field: 'appt_id', headerName: 'Appt Id', width: 200},
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 200},
    { field: 'pat__patient', headerName: 'Patient', width: 200 },
    { field: 'addedby', headerName: 'Added by', width: 150 },
    { field: 'add_date_date', headerName: 'Appt Slot', width: 150 },
    { field: 'action', headerName: 'Action',
      renderCell: (params) => (
          <Link to={`/drug-pay-dr/${params.row.id}`} className="btn btn-success">
            View
          </Link>
      ),
    width: 100 },
  ];
  const columnsS = [
    { field: 'add_date', headerName: 'Added Date', width: 100},
    { field: 'id', headerName: 'Id', width: 80},
    {
      field: 'pat_pat_id',
      headerName: 'Patient ID',
      width: 100,
      renderCell: (params) => {
        if (params.row.pat) {
          return params.row.pat.pat_id || '';
        }
        return '';
      }
    },
    { field: 'patient', headerName: 'Patient', width: 200 },
    { field: 'addedby', headerName: 'Added by', width: 150 },
    { field: 'action', headerName: 'Action',
      renderCell: (params) => (
          <Link to={`/drug-pay-save/${params.id}`} className="btn btn-success">
            View
          </Link>
      ),
    width: 100 },
    { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },
  ];
    const handleDelete = (sav_id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-save-pharm/'+sav_id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
  useEffect(() => {
    fetchIpData();
  }, []);

  useEffect(() => {
      if (ipData.length > 0) {
        setRowsIp(ipData);
      }
  }, [ipData]);

  function fetchIpData() {
    setIsLoading(true);
    axios.get(`${baseUrl}view-drugip/`)
      .then(response => {
        setIpData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

const columns3 = [
  {
    field: 'ip_id',
    headerName: 'IP ID',
    width: 200,
    renderCell: (params) => params.row.ip__ip_id,
  },
  {
    field: 'pat__pat_id',
    headerName: 'Patient ID',
    width: 200,
    renderCell: (params) => params.row.pat__pat_id,
  },
  {
    field: 'pat__patient',
    headerName: 'Patient',
    width: 200,
    renderCell: (params) => params.row.pat__patient,
  },
  {
    field: 'addedby',
    headerName: 'Added by',
    width: 150,
    renderCell: (params) => params.row.addedby,
  },
  {
    field: 'add_date',
    headerName: 'Raised On',
    width: 150,
    renderCell: (params) => params.row.add_date_date,
  },

  {
    field: 'action',
    headerName: 'Action',
    renderCell: (params) => (
      <Link to={`/drug-ip-pay/${params.row.id}/`} className="btn btn-success">
        View
      </Link>
    ),
    width: 100,
  },
];

useEffect(() => {
    fetchData2();
  }, []);

  useEffect(() => {
      if (indentData.length > 0) {
        setRowsindent(indentData);
      }
  }, [indentData]);
  function fetchData2() {
    setIsLoading(true);
    axios.get(`${baseUrl}indent-drug-view/`)
      .then(response => {
        setIndentData(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
    const columns2 = [
    { field: 'dept', headerName: 'Department', width: 200 },
    { field: 'user', headerName: 'Department User', width: 200 },
    { field: 'addedby', headerName: 'Added by', width: 150 },
    { field: 'add_date_date', headerName: 'Added On', width: 150 },
    { field: 'action', headerName: 'Action',
      renderCell: (params) => (
          <Link to={`/drug-pay-indent/${params.row.id}`} className="btn btn-success">
            View
          </Link>
      ),
    width: 100 },
  ];

    return (
    <section className="container mt-4">
    <div className="row">
    <div className="col-md-6">
     <div className="form-group">
      <label className="col-sm-3 col-lg-2 control-label">Search Patient</label>
      <div className="col-sm-9 col-lg-10 controls">
        <input className="form-control" type="headerName" placeholder="pat id, address, name, mobile"
                           value={searchTerm} onChange={handleSearchInputChange} />
              <button className="btn btn-primary" onClick={() => fetchData()}>Search</button>
            </div>
     </div>
    </div>
    <div className="col-md-6 mt-4">
     <div className="form-group">
          <Link to={`/drug-pay-other/0`} className="btn btn-danger">
            Others <i className="fa-solid fa-prescription-bottle-medical" aria-hidden="true" style={{color: 'white'}}></i>
          </Link>
     </div>
    </div>

    {!isLoading && patients.length > 0 ? (
        <div style={{ height: '100%', width: '100%' }}>
            <DataGrid
            sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            }}
            rows= {patients}
            columns= {columns}
            pageSize= {10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
            />
        </div>
    ) : (
      <></>
    )}
    {!isLoading && opvData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }} className="mt-4">

       <h3 className="text-center mt-4" style={{color: 'black', backgroundColor: '#e5eaef'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       OP Patients View</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={oprows}
            columns={columnsop}
            pageSize={10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
          />
        </div>
      ) : (
        <></>
      )}
     {!isLoading && opData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
       <h3 className="text-center mt-4" style={{color: 'black', backgroundColor: '#e5eaef'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Consultant Request View</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns1}
            pageSize={10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
          />
        </div>
      ) : (
        <></>
     )}
     {!isLoading && savData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
       <h3 className="text-center mt-4" style={{color: 'black', backgroundColor: '#e5eaef'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       Saved Request View</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={savrows}
            columns={columnsS}
            pageSize={10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
          />
        </div>
      ) : (
        <></>
     )}
     {!isLoading && ipData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
       <h3 className="text-center mt-4" style={{color: 'black', backgroundColor: '#e5eaef'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
       IP Request View</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rowsip}
            columns={columns3}
            pageSize={10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
          />
        </div>
      ) : (
        <></>
     )}

     {!isLoading && indentData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
       <h3 className="text-center mt-4" style={{color: 'black', backgroundColor: '#e5eaef'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
        Indent Request View</h3>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rowsindent}
            columns={columns2}
            pageSize={10}
            slots={{ toolbar: GridToolbar }}
            autoHeight
          />
        </div>
      ) : (
        <></>
     )}

    </div>
    </section>
    )
}

export default DrugView;
